import { useEffect, useState } from "react";
import PaymentService from '../../services/paymentService';

const useCards = ({ filters } = {}) => {
    const [cards, setCards] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = async () => {
            setLoading(true);
            PaymentService
                .SearchCards({ pageSize: 100, pageNumber: 1, ...filters })
                .then(res => setCards({
                    ...cards,
                    items: res.values.filter(e => e.active === true),
                    totalResults: res.totalResults,
                    totalPage: res.totalPage
                }))
                .finally(() => setLoading(false))
        }
        if (!loading)
            getFromServer();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    return {
        cards: cards?.items || [],
        loading,
        totalResults: cards?.totalResults,
        totalPage: cards?.totalPage
    }
}
export default useCards;